exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shadow-wish[data-v-04aedbe5]{text-shadow:2px 3px 8px #000}@media (max-width:768px){.align-title[data-v-04aedbe5]{margin-left:auto;margin-right:auto;white-space:nowrap}}", ""]);

// exports
